import { call, put } from 'redux-saga/effects';
import { config } from '../../api/config';
import { Api } from '../../api/api';
import { actions } from '..';
import { errorMessage } from '../../utils';

export function* getLoyaltyProgramsSaga({ filter: initialFilter }) {
  try {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(true));

    const body = {
      ...initialFilter,
      limit: config.DEFAULTS.recordsPerPage,
    };

    const { loyalty_programs, count, header } = yield call(
      Api.getLoyaltyPrograms,
      body
    );

    yield put(
      actions.loyaltyProgram.setLoyaltyProgramsAction(
        loyalty_programs,
        count,
        header
      )
    );
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(false));
  }
}

export function* getLoyaltyProgramSaga({ id }) {
  try {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(true));

    const loyaltyProgram = yield call(Api.getLoyaltyProgram, id);

    yield put(actions.loyaltyProgram.setLoyaltyProgramAction(loyaltyProgram));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(false));
  }
}

export function* addLoyaltyProgramSaga({ body, history }) {
  try {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(true));

    yield call(Api.createLoyaltyProgram, body);

    history.push(config.APP_PATHS.loyaltyProgram);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(false));
  }
}

export function* editLoyaltyProgramSaga({ id, body }) {
  try {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(true));

    const loyaltyProgram = yield call(Api.updateLoyaltyProgram, id, body);

    yield put(actions.loyaltyProgram.setLoyaltyProgramAction(loyaltyProgram));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(false));
  }
}

export function* deactivateLoyaltyProgramSaga({ id, history }) {
  try {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(true));

    yield call(Api.deleteLoyaltyProgram, id);

    history.push(config.APP_PATHS.loyaltyProgram);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.loyaltyProgram.setLoyaltyProgramsLoadingAction(false));
  }
}
